import React from 'react';
import { useAppContext } from 'src/components/app-context';
import { OptionTypeEnum } from 'src/components/filter-dropdown';
import { sortOffersByPrice } from 'src/components/price-list/sort-by-price';
import { useOfferListFilterContext } from '../../../offer-list-filter-context';
import { PriceRowContextContainer } from '../../../price-list/price-row-context';
import { createOfferFromPriceItem } from '../../../price-list/utils';
import { useProductContext } from '../../../product-context';
import type { IOurChoiceOffer } from './types';
import { OurChoicePriceRow } from '../../../price-list/price-row/row-types/our-choice-offer-in-header';
import { ViewSize } from '../../../price-list/price-row/types';
import { getOurChoiceOffer } from './utils';
import { OurChoiceHeader } from './title-with-popover';
import { OurChoiceWrapper } from './styles';

export const OurChoice = (props: IOurChoiceOffer) => {
  const { campaign } = props;
  const { market } = useAppContext();
  const { product, offers } = useProductContext();
  const { getPriceDisplay } = useOfferListFilterContext();
  const currentSorting = OptionTypeEnum.CHEAPEST_PRICE;

  const offersSorted = sortOffersByPrice(
    getPriceDisplay(),
    offers.filteredOffers
  );
  const ourChoice = getOurChoiceOffer(offersSorted, market.code);

  if (!ourChoice) {
    return null;
  }

  const offer = createOfferFromPriceItem(ourChoice);

  return (
    <OurChoiceWrapper>
      <OurChoiceHeader />
      <PriceRowContextContainer
        offer={offer}
        product={product}
        isFeatured={Boolean(offer.featured && offer.externalUri)}
        sorting={currentSorting}
        campaign={campaign}
        viewSize={ViewSize.SMALL}
        isInPriceList={false}
        isOurChoice
      >
        <OurChoicePriceRow item={ourChoice} index={0} />
      </PriceRowContextContainer>
    </OurChoiceWrapper>
  );
};
